
import { defineComponent, onMounted } from 'vue';
import { AppButton, AppCard } from '@/components';
import { useLiveopsLeaderboardList } from '@/modules/liveops/leaderboard/model/list';
import { ROUTE_NAME_LIVEOPS } from '@/modules/liveops/router';
import LeaderboardTable from '@/modules/liveops/leaderboard/view/table.vue';

export default defineComponent({
    name: 'LiveopsLeaderboardList',
    components: { AppButton, AppCard, LeaderboardTable },
    setup() {
        const { list, total, fetchList, actions, itemInfo } = useLiveopsLeaderboardList();

        onMounted(() => fetchList());

        return { list, total, fetchList, actions, itemInfo, ROUTE_NAME_LIVEOPS };
    }
});
